module.exports = __webpack_public_path__ + "static/img/jprm-02.ac570f70.jpg";